import { ResourceVm } from 'qp-ui-interface';
import { ParentalControlLevels } from './../services/evergent/parental-control/model/get-parental-control-level.response';

export const getAllowLevels = (
  parentalLevels: ParentalControlLevels[],
  ageGroup: string
): string[] => {
  const allowedLeveles = [] as Array<string>;
  let isAgeGroup = false;
  parentalLevels?.forEach((value) => {
    if (!isAgeGroup) {
      allowedLeveles.push(value.name.replace(/\s/g, ''));
    }
    if (value.name.replace(/\s/g, '') === ageGroup) isAgeGroup = true;
  });
  return allowedLeveles;
};

export const isWatchableContent = (
  allowedLevels: string[],
  resource: ResourceVm
): boolean => {
  let isWatchable = false;
  if (
    !resource.ratings ||
    resource.ratings?.length <= 0 ||
    resource.contentType === 'trailer'
  )
    return true;
  resource.ratings.forEach((rating) => {
    if (allowedLevels.includes(rating.v.replace(/\s/g, ''))) isWatchable = true;
  });
  return isWatchable;
};
